import store from '@/store'
import { ErrorService } from "../helpers/errorplugin"
const $log = ErrorService

const PERIODS = {
  MONTH: { seconds: (30 * 24 * 60 * 60), key: "MONTH" }
}

function period() {
  return PERIODS['MONTH']
}

function topup(newtierprice, currenttierprice, secondsremaining, durationpurchase) {
  // Price for top-up part = (Tn-Tc)*(Dc/Dp) 
  $log.onDebug("new price:" + newtierprice
    + " current price:" + currenttierprice + " remaining:" + secondsremaining + " duration:" + durationpurchase)
  let topupprice = (newtierprice - currenttierprice) * (secondsremaining / durationpurchase)

  $log.onDebug("topup price calculated:" + topupprice)
  return topupprice
}


function adjustuntil(currenttierkey, selectedtierkey, secondsremaining) {
  // new tier credit = Dc x (c/n) 
  return secondsremaining * (currenttierkey / selectedtierkey)
}

function secondsuntil(until) {
  let now = Math.floor(Date.now() / 1000)
  let expires = new Date(until)
  return (expires.getTime()/1000) - now
}

function allProducts(){
  return store.getters['pricing/getProducts']
}

function productFromID(id){  
  let prods = allProducts();
  $log.onTrace("looking for " + id + " in :" + JSON.stringify(prods))
  let found = prods.find(s => s.productid === id)
  $log.onTrace("got " + JSON.stringify(found))
  return found
}

const PricingPlugin = {
  install(Vue, options) {
    Vue.prototype.$pricing = {
      PERIODS: PERIODS,
      topup: topup,
      adjustuntil: adjustuntil,
      period: period,
      secondsuntil: secondsuntil,
      productFromID: productFromID
    }
  },
}

export {
  PricingPlugin,
  PERIODS,
  topup,
  adjustuntil,
  secondsuntil,
  period,
  productFromID
}
